import React from "react";

import getWeatherIcon from "../utils/getWeatherIcon";
import formatDay from "../utils/formatDay";

class Day extends React.Component {
  render() {
    const { date, max, min, code, isToday } = this.props;

    return (
      <li className="day">
        <span>{getWeatherIcon(code)}</span>
        <p>{isToday ? "Today" : formatDay(date)}</p>
        <p>
          <strong>
            {Math.floor(min)}&deg; &mdash; {Math.ceil(max)}&deg;
          </strong>
        </p>
      </li>
    );
  }
}

export default Day;
